import React, {RefObject} from 'react';

interface IVolumeProps {
  volumeRef: RefObject<HTMLDivElement>;
  volumeSliderWrapRef: RefObject<HTMLDivElement>;
  barShow: string;
  slider: {
    percent: number;
    cssClass: string;
  };
  onMouseMove: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onMouseDown: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onMouseUp: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onMouseLeave: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onClickSound: () => void;
}

/**
 * 컨트롤 바 > 볼륨 컴포넌트
 */
const Volume = ({
  volumeRef,
  volumeSliderWrapRef,
  barShow,
  slider,
  onMouseMove,
  onMouseDown,
  onMouseUp,
  onMouseLeave,
  onClickSound,
}: IVolumeProps) => {
  const volumeHandlerStyle = {
    left: `${slider.percent}%`,
  };
  const volumeRangeStyle = {
    width: `${slider.percent}%`,
  };

  return (
    <div className={'volume ' + barShow} ref={volumeRef}>
      <button
        type='button'
        className={'sound ' + slider.cssClass}
        id='btn_sound'
        onClick={onClickSound}>
        <span></span>
        <span></span>
      </button>
      <div
        className='volume_slider_wrap'
        ref={volumeSliderWrapRef}
        onMouseMove={onMouseMove}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onMouseLeave={onMouseLeave}>
        <div className='volume_slider'>
          <div className='volume_range' style={volumeRangeStyle}></div>
          <button
            className='volume_handler'
            style={volumeHandlerStyle}></button>
        </div>
      </div>
    </div>
  );
};

export default Volume;
